export default __webpack_public_path__ + "static/media/part1_title_m.e4f0ed85.png";